import { getLicence } from '../licence';
import { getArticleRoute } from '../router';

export function getTermsAndConditionsRoute() {
    return getArticleRoute(
        `support-terms-and-conditions-${getLicence().toLowerCase()}`,
        'support.terms-and-conditions',
    );
}
